/**
 * confirmModal module
 */
export const ConfirmModalStoreModule = {
  namespaced: true,
  state: () => {
    return {
      modals: new Set(),
    };
  },
  mutations: {
    ADD_MODAL(state, val) {
      const copy = new Set(state.modals).add(val);
      state.modals = copy;
    },
    REMOVE_MODAL(state, val) {
      const copy = new Set(state.modals);
      copy.delete(val);
      state.modals = copy;
    },
    CLEAR_MODALS(state) {
      state.modals.clear();
      state.modals = new Set();
    },
  },
  actions: {
    open({ commit }, payload) {
      commit('ADD_MODAL', payload);
    },
    close({ commit }, payload) {
      commit('REMOVE_MODAL', payload);
    },
  },
};
